import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const fundStrategyList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/unit-fund/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};

export const fundStrategyAdd = (params) => {
  return _baseClient.post('/unit-fund/save', { body: params }).then((response) => {
    return response;
  });
};

export const fundStrategyDelete = (params) => {
  return _baseClient.get('/unit-fund/delete', params);
};

export const fundStrategyDetail = (params) => {
  return _baseClient.get('/unit-fund/get', params);
};

export const fundStrategUpdateStatus = (params) => {
  return _baseClient.get('/unit-fund/update-status', params);
};
